import { useMutation, useQuery, useQueryClient } from 'react-query';

import { Route } from 'RestAPIs/travel-distances/types';

import { getCountries } from 'RestAPIs/countries';
import {
  createRoute,
  deleteRoute,
  updateRoute
} from 'RestAPIs/travel-distances';

import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

export const useGetCountriesQuery = () =>
  useQuery(
    ['countries'],
    async () => {
      const { data } = await getCountries();
      return data;
    },
    {
      staleTime: Infinity // we only need to fetch this list once
    }
  );

export const useSaveTravelDistanceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (route: Route) => {
      if (route.id) {
        return updateRoute(route);
      } else {
        return createRoute(route);
      }
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['travelDistances']);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export const useDeleteTravelDistanceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((id: number) => deleteRoute(id), {
    onSuccess: async () => {
      await queryClient.invalidateQueries(['travelDistances']);
      showSuccessSnackbar();
    },
    onError: () => {
      showErrorSnackbar();
    }
  });
};
